export default __webpack_public_path__ + "static/media/post-suvinil6.8ee4c630.png";